import { render, staticRenderFns } from "./button-block.html?vue&type=template&id=22203527&scoped=true&"
import script from "./button-block.js?vue&type=script&lang=js&"
export * from "./button-block.js?vue&type=script&lang=js&"
import style0 from "./button-block.scss?vue&type=style&index=0&id=22203527&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22203527",
  null
  
)

export default component.exports